import { VscStarFull, VscStarEmpty } from 'react-icons/vsc';

const StarRating = ({ rating }) => {
    const filledStars = Math.floor(rating); // Number of filled stars
    const hasHalfStar = rating - filledStars >= 0.5; // Check for half star
    const emptyStars = 5 - filledStars - (hasHalfStar ? 1 : 0); // Number of empty stars

    // Create an array of stars to render
    const stars = [];
    for (let i = 0; i < filledStars; i++) {
        stars.push(<VscStarFull className="flex-shrink-0 size-5" key={`star-filled-${i}`} />);
    }

    if (hasHalfStar) {
        stars.push(<VscStarFull className="flex-shrink-0 size-5" key={`star-half`} />);
    }

    for (let i = 0; i < emptyStars; i++) {
        stars.push(<VscStarEmpty className="flex-shrink-0 size-5" key={`star-empty-${i}`} />);
    }

    return (
        <div className="flex items-center gap-1 star-rating">
            {stars.map((star, index) => (
                <span key={index} className="w-4 h-4 text-yellow-500">
                    {star}
                </span>
            ))}
        </div>
    );
};

export default StarRating;
